import {useSelector} from 'react-redux';
import {SuccessHeader} from '~/CreateFabricGreetingCard/routes/Success/SuccessHeader';
import {Divider} from '~library/atoms/Divider';
import {Card} from '~/CreateFabricGreetingCard/routes/Success/Card/Card';
import {useMatchQuery} from '~/common/hooks/useMatchQuery';
import {selectDeliverCardNow} from '~/common/fabric/reducers/review/selectors';
import {
  selectGiftCardData,
  selectHasGiftCard,
} from '~/CreateFabricGreetingCard/reducers/eviteEvent/selectors';
import {GiftCard} from '~/common/fabric/GiftCard/components/GiftCard/GiftCard';
import {largishAndUpQuery} from '~libSass/base/_exports.sass';
import {useCartEndpoints} from '~/CreateFabricInvitation/hooks/useCartEndpoints';
import {getEventId} from '~/common/fabric/reducers/eviteEvent/selectors';
import {OrderDetails} from '~/common/fabric/Checkout/OrderDetails';

export const Success = () => {
  const appRoot = document.getElementById('fabric-create-greeting-card-root');
  appRoot.classList = ['fabric-create-greeting-card-root confirm'];
  const eventId = useSelector(getEventId);
  const eviteEvent = useSelector((state) => state.eviteEvent);
  const deliverCardNow = useSelector(selectDeliverCardNow);
  const {matches: isDesktop} = useMatchQuery(`(${largishAndUpQuery})`);
  const hasGiftCard = useSelector(selectHasGiftCard);
  const giftCard = useSelector(selectGiftCardData);
  // when user has pro and no gift card, we never checked out so don't try and request any cart data,
  // but if there is a gift card, we checked out
  const {checkoutData} = useCartEndpoints(eventId);

  return (
    <div className="card-success">
      <SuccessHeader
        ctaText={hasGiftCard ? 'Send Another eGift Card' : 'Send to More Recipients'}
        cta={`/cards/${eviteEvent.template_name}/create`}
        subText={deliverCardNow ? 'Your card has been sent.' : 'Your card has been scheduled.'}
        qaId="button-manage"
      />

      <Divider marginTop={24} marginBottom={24} />

      <Card />

      {hasGiftCard && giftCard && (
        <GiftCard
          guestsQuantity={checkoutData?.guestsAdded}
          giftCard={giftCard}
          className="card-success__gift_card"
        />
      )}

      {isDesktop && <Divider marginTop={24} marginBottom={24} />}

      {checkoutData && <OrderDetails />}
    </div>
  );
};
